import { RequirePermission } from '@components/routing/RequirePermission/RequirePermission';
import { Crisp } from '@innovatm/js-crisp';
import { ErrorBoundary } from '@sentry/react';
import { AccessPermissions } from '@types';
import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';
import { SettingsPage } from 'views/Settings/SettingsPage/SettingsPage';

import { useCurrentUser } from '../contexts/OidcContext/OidcContext.selectors';
import { ROUTE_HELP, ROUTE_HOME, ROUTE_REQUESTS, ROUTE_SCHEDULE, ROUTE_SETTINGS } from '../routes';
import { HelpPage } from './Help/HelpPage';
import { RequestPage } from './Request/RequestPage/RequestPage';
import { SchedulePage } from './Schedule/SchedulePage/SchedulePage';

export const App = memo(function App() {
    const email = useCurrentUser()?.email;

    return (
        <>
            <ErrorBoundary showDialog={false} fallback={() => null}>
                <Crisp appId={import.meta.env.VITE_CRISP_APP_ID} email={email} />
            </ErrorBoundary>
            <Routes>
                <Route
                    path={ROUTE_HOME}
                    element={
                        <RequirePermission requiredPermission={AccessPermissions.GANTT_PAGE}>
                            <SchedulePage />
                        </RequirePermission>
                    }
                />
                <Route
                    path={ROUTE_REQUESTS}
                    element={
                        <RequirePermission requiredPermission={AccessPermissions.REQUEST_PAGE}>
                            <RequestPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path={ROUTE_SCHEDULE}
                    element={
                        <RequirePermission requiredPermission={AccessPermissions.GANTT_PAGE}>
                            <SchedulePage />
                        </RequirePermission>
                    }
                />
                <Route path={ROUTE_SETTINGS} element={<SettingsPage />} />
                <Route path={ROUTE_HELP} element={<HelpPage />} />
            </Routes>
        </>
    );
});
